import { render, staticRenderFns } from "./FotosTeoricasPraticas.vue?vue&type=template&id=3521419a"
import script from "./FotosTeoricasPraticas.vue?vue&type=script&lang=js"
export * from "./FotosTeoricasPraticas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports